import React from "react";
import { Link } from "react-router-dom";

// Reused Home icon SVG (same path as the navbar menu home icon)
// Color changed from white to #6E727B to match breadcrumb styling
const HomeIconSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_478_766)">
      <path
        d="M11.0833 13.9997H2.91667C1.30842 13.9997 0 12.6913 0 11.083V5.67203C0 4.70078 0.480667 3.79661 1.28567 3.25411L5.36842 0.498445C6.3595 -0.170055 7.6405 -0.170055 8.63158 0.498445L12.7149 3.25411C13.5193 3.79661 14 4.7002 14 5.67203V11.083C14 12.6913 12.6916 13.9997 11.0833 13.9997ZM7 1.16461C6.65933 1.16461 6.31867 1.26495 6.02117 1.4662L1.93783 4.22128C1.45483 4.54678 1.16667 5.0887 1.16667 5.67145V11.0824C1.16667 12.0473 1.95183 12.8324 2.91667 12.8324H11.0833C12.0482 12.8324 12.8333 12.0473 12.8333 11.0824V5.67203C12.8333 5.08928 12.5452 4.54678 12.0627 4.22186L7.97883 1.4662C7.68133 1.26495 7.34067 1.16461 7 1.16461Z"
        fill="#6E727B"
      />
    </g>
    <defs>
      <clipPath id="clip0_478_766">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ChevronRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6 12L10 8L6 4"
      stroke="#6E727B"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AdvertiseHero = ({ hero }) => {
  return (
    <div className="inner-banner">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center mx-auto">
            <ul className="breadcrumps">
              <li>
                <Link to="/">
                  <HomeIconSvg />
                  Home
                </Link>
              </li>
              <li>
                <ChevronRight />
              </li>
              <li className="breadcrumps-current">{hero.title || "Advertise With Us"}</li>
            </ul>
            <p>{hero.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertiseHero;
